import { JS_VALUES } from '../constants';

const HASH_ENCODED = '%23';

export function getQueryParams(url) {
  if (typeof url === 'string' && url.split('?')[1]) {
    return (
      url.split &&
      url
        .split('?')[1]
        .replace(new RegExp('#', 'g'), HASH_ENCODED)
        .split('&')
        .filter(qp => qp !== '')
        .map(qp => qp.split('='))
        .reduce(
          (aggr, qpPair, i) =>
            Object.assign(aggr, {
              [qpPair[0]]: decodeURIComponent(qpPair[1]) || '',
            }),
          {}
        )
    );
  }
}

export function getQueryParamValue(location, key) {
  const qParams = getQueryParams(location.href) || {};
  return qParams[key] || '';
}

export function getSubdomain({ hostname }) {
  return hostname.split('.')[0];
}

function setInSessionStorage(key, value) {
  typeof sessionStorage !== JS_VALUES.UNDEFINED &&
    sessionStorage.setItem(key, value);
}

function removeFromSessionStorage(key) {
  typeof sessionStorage !== JS_VALUES.UNDEFINED &&
    sessionStorage.removeItem(key);
}

function getFromSessionStorage(key) {
  return (
    typeof sessionStorage !== JS_VALUES.UNDEFINED && sessionStorage.getItem(key)
  );
}
export function getCookie(cookieName) {
  var name = cookieName + '=';
  var cookieValues = document.cookie.split(';');
  for (var i = 0; i < cookieValues.length; i++) {
    var cookieValue = cookieValues[i];
    while (cookieValue.charAt(0) === ' ')
      cookieValue = cookieValue.substring(1);
    if (cookieValue.indexOf(name) === 0) {
      var valueToReturn = cookieValue.substring(
        name.length,
        cookieValue.length
      );
      return valueToReturn;
    }
  }
  return null;
}

//For tests
export const SessionStorageUtil = {
  setInSessionStorage,
  removeFromSessionStorage,
  getFromSessionStorage,
};



// WEBPACK FOOTER //
// ./src/utils/index.js